import {getTimestampNow} from "../../../util/Util";
import {
    deleteVaprDeviceDetails,
    fetchVaprDeviceDetails,
    updateVaprConfiguration
} from "../network/VaprDeviceNetworkAPI";

export const VaprDeviceOverviewReducer = (state, action) => {
    switch(action.type) {
        case "LOAD_VIEW":
            fetchVaprDeviceDetails(action.data.dispatcher)
            return state
        case "RECEIVE_DATA":
            return {...state, ...action.data, loadingOverview: false, timestamp: getTimestampNow()}
        case "SORT_DATA":
            return {...state, sortPref: action.data}
        case "UPDATE_VAPR_CONFIGURATION":
            updateVaprConfiguration(action.data.dispatcher, action.data.configurations, action.data.mac,
                action.data.showCustomAlert)
            return state
        case "DELETE_DEVICE_DATA":
            deleteVaprDeviceDetails(action.data.dispatcher, action.data.mac, action.data.showCustomAlert)
            return state
        default:
            return state
    }
}



// WEBPACK FOOTER //
// ./src/components/devicemanagement/vaprdevice/reducer/VaprDeviceOverviewReducer.js